import { AlertTriangle } from 'lucide-react'

/** The message a caught render error leaves in place of the screen. */
export default function ErrorPanel({
  title,
  detail,
  actionLabel,
  onAction,
}: {
  title: string
  detail: string
  actionLabel: string
  onAction: () => void
}) {
  return (
    <div role="alert" className="flex h-full w-full items-center justify-center p-8">
      <div className="max-w-lg rounded-lg border border-red-400/20 bg-black/30 px-6 py-5 text-center">
        <AlertTriangle size={18} className="mx-auto text-red-300" />
        <p className="mt-3 text-[13px] font-medium text-stone-200">{title}</p>
        <p className="mt-1.5 text-[11px] leading-relaxed text-stone-500">{detail}</p>
        <button
          type="button"
          onClick={onAction}
          className="mt-4 rounded-md border border-amber-400/25 bg-amber-400/[0.08] px-3 py-1.5 text-[11px] font-medium text-amber-200 transition-colors hover:border-amber-400/40"
        >
          {actionLabel}
        </button>
      </div>
    </div>
  )
}
